import styles from "./Checkbox.module.css";

export default function Checkbox({ label, ...inputProps }) {
  return (
    <label className={`${styles.checkbox} d-inline-flex align-items-center`}>
      <input type="checkbox" className={styles.input} {...inputProps} />
      <span>{label}</span>
    </label>
  );
}
